import { Messages } from '../../codegen/Localize';
import { SiteRoles } from '../../ts/ServerApi/types/ISiteRole';

export namespace SiteRolesHelper {
  export function siteRoleToName(siteRole: string): string {
    switch(siteRole) {
      case SiteRoles.ServerAdministrator: return Messages.siteRole_ServerAdministrator();
      case SiteRoles.SiteAdministratorCreator: return Messages.siteRole_SiteAdministratorCreator();
      case SiteRoles.SiteAdministratorExplorer: return Messages.siteRole_SiteAdministratorExplorer();
      case SiteRoles.SupportUser: return Messages.siteRole_SupportUser();
      case SiteRoles.Creator: return Messages.siteRole_Creator();
      case SiteRoles.ExplorerCanPublish: return Messages.siteRole_ExplorerCanPublish();
      case SiteRoles.Explorer: return Messages.siteRole_Explorer();
      case SiteRoles.Viewer: return Messages.siteRole_Viewer();
      case SiteRoles.Unlicensed: return Messages.siteRole_Unlicensed();
      case SiteRoles.Guest: return Messages.siteRole_Guest();
    }
  }
}
